import './component.scss'
import '../../generals/company_card_list/component.js'
import { Turbo } from "@hotwired/turbo-rails"

Turbo.session.drive = false
